import React from "react";

import styles from "./index.module.scss";
import { BackButton } from "./Components/BackButton";

export interface MHeaderProps {
    title: string;
    goBack: () => void;
    extra?: React.ReactNode;
}

const MHeader = ({ title, goBack, extra }: MHeaderProps) => {
    return (
        <div className={styles.header}>
            <BackButton onClick={goBack} />

            <div className={styles.title}>{title}</div>

            {extra && <div className={styles.extra}>{extra}</div>}
        </div>
    );
};

export default MHeader;
